








import { defineComponent, computed, useContext, onMounted, ref } from '@nuxtjs/composition-api';
import { useUser } from '~/composables';
import { getUserIsLogged } from '~/helpers/user/user';
import { ADD_TO_WISHLIST_ICON_ANIMATION } from '~/utils/constants/layout';

export default defineComponent({
  name: 'AddToWishlist',

  props: {
    sku: {
      type: String,
      required: true,
    },
    isInWishlist: {
      type: Boolean,
      default: false,
    },
    wishlistIcon: {
      type: String,
      default: 'heart',
    },
    isInWishlistIcon: {
      type: String,
      default: 'heart_fill',
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  setup(props) {
    const { $cookies } = useContext();
    const actionText = computed(() => (props.isInWishlist ? 'Remove from Wishlist' : 'Add to Wishlist'));
    const isAuthenticated = computed(() => getUserIsLogged($cookies))
    const { isAuthenticated: isMagentoAuthenticated} = useUser();
    const customLoading = ref(false)

    onMounted(()=>{
      const actions = $cookies.get('pendingActions') || [];
      const addToWishlist = actions.find(el=>el.name=='addToWishlist');
      if(addToWishlist){
        customLoading.value=true
      }
    })
    return {
      actionText,
      isAuthenticated,
      isMagentoAuthenticated,
      ADD_TO_WISHLIST_ICON_ANIMATION,
      customLoading,
      isLoading: computed(()=>props.loading || customLoading.value)
    };
  },
  methods: {
    clickHandler(evt) {
      evt.stopPropagation();
      const $t = this as any; //vs-cod linter trick
      $t.customLoading = false;
      if ($t.isAuthenticated && $t.isMagentoAuthenticated) {
        $t.$emit('addToWishlist')
      } else if(!$t.isAuthenticated){
        const pendingActionsCookie = $t.$cookies.get('pendingActions');

        let actions = pendingActionsCookie ? pendingActionsCookie : []
        actions.push({ name: 'addToWishlist', data: $t.sku })
        $t.$cookies.set('pendingActions', actions);
        document.getElementById('login-button')?.click();
      }
    }
  }
});
